import { useState } from 'react';
import PlanCanvas from './Components/PlanCanvas/PlanCanvas'
import AboveViewCanvas from './Components/AboveViewCanvas/AboveViewCanvas';
import mockPlans from '../mock.json';
import InfoMessage from '../Components/NothingMatches';
import Loading from '../Components/Loading/Loading';
import CurrentRoom from './Components/CurrentRoom/CurrentRoom';
import './Floors.scss';
import { useContext } from 'react';
import { Context } from '../App';


const plans = mockPlans.map(plan => {
    const path = JSON.parse(plan.path);

    plan.path = path;
    return plan;
});


export default function Flats ({planImage}) {
    const {initialProps, facilityId} = useContext(Context);
    const [loading, setLoading] = useState(false);
    const [step, setStep] = useState(0);
    const [error, setError] = useState();
    const [entrance, setEntrance] = useState();
    const [currentRoom, setCurrentRoom] = useState();
    
    
    const increaseStep = () => {
        if (step < 3)
            setStep(step + 1)
    }

    const decreaseStep = () => {
        if (step > 0)
            setStep(step - 1)
    }

    const handleEntrance = (entranceId) => {
        setEntrance(entranceId);
        increaseStep();
    }

    const handleCurrentRoom = ({id, type}) => {
        setCurrentRoom({id, type});
        increaseStep();
    }


    if (error) {
        return <InfoMessage>Произошла ошибка! Перезагрузите страницу или повторите попытку позже</InfoMessage>
    }

    return (
        <>
            <div className="floors-control">
                { step > 0 &&
                    <button className="floors-control__button" onClick={decreaseStep}>&#8592; Назад</button>
                }
            </div>
            { loading && <Loading /> }
            { step === 0 && 
                <PlanCanvas 
                    plans={plans} 
                    handleEntrance={handleEntrance}
                    planImage={planImage}
                /> 
                }
            { step === 1 && 
                <AboveViewCanvas 
                    defaultEntrance={entrance} 
                    plans={plans} 
                    setLoading={setLoading} 
                    facilityId={facilityId} 
                    handleCurrentRoom={handleCurrentRoom}
                /> 
            }
            { step === 2 && 
                <CurrentRoom 
                    currentRoom={currentRoom} 
                    setLoading={setLoading}
                />
            }
        </>
    )
}